<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    props: {
        value: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Input some text...",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["input"],
    data: () => ({}),
    computed: {},
    methods: {
        onInput(event: Event): void {
            const target = event.target as HTMLInputElement;
            this.$emit("input", target.value);
        },
    },
});
</script>

<template>
    <div class="generic-input flex flex--valign-c">
        <input class="generic-input-field" type="text" :value="value" :placeholder="placeholder" :disabled="disabled" autocomplete="off" autocorrect="off" autocapitalize="off" :spellcheck="false" @input="onInput" />
    </div>
</template>

<style lang="scss" scoped>
.generic-input {
    width: 100%;
    min-height: rem(65);

    border-radius: rem(8);
    background-color: $color-accent-light-a;

    &::after {
        content: "";
        position: absolute;
        left: rem(10);
        right: rem(10);
        top: calc(100% + #{rem(5)});
        height: rem(5);
        background-color: $color-accent-light-a;
        border-radius: rem(10);
    }

    .generic-input-field {
        width: 100%;
        height: 100%;
        display: block;
        box-sizing: border-box;
        border: 0;
        outline: 0;
        appearance: none;
        -webkit-appearance: none;

        padding: 0 rem(25);
        background: transparent;
        color: inherit;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;

        &::placeholder {
            color: currentColor;
            opacity: 0.5;
            font-weight: 400;
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.6;
        }

        &::-ms-clear,
        &::-ms-reveal {
            display: none;
        }

        &::-webkit-search-decoration,
        &::-webkit-search-cancel-button,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
            display: none;
        }
    }
}

@include media-breakpoint-down(lg) {
    .generic-input {
        min-height: rem(60);
    }
}
@include media-breakpoint-down(md) {
    .generic-input {
        min-height: rem(50);
    }
}
@include media-breakpoint-down(sm) {
    .generic-input {
        min-height: rem(40);

        .absolute-content {
            top: 50%;
            right: rem(-35);
            transform: translateY(-50%);
        }
    }
}
</style>
